export function detectBrowser() { 
    const platform = navigator.userAgentData ? navigator.userAgentData.platform : 'Unknown'
  if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) {
      return 'Opera Mini' + ', ' + platform;
  } else if(navigator.userAgent.indexOf("Chrome") != -1 ) {
      return 'Google Chrome' + ', ' + platform;
  } else if(navigator.userAgent.indexOf("Safari") != -1) {
      return 'Safari' + ', ' + platform;
  } else if(navigator.userAgent.indexOf("Firefox") != -1 ){
      return 'Mozilla Firefox' + ', ' + platform;
  } else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) {
      return 'Internet Explorer' + ', ' + platform;
  } else {
      return 'Unknown Browser' + ', ' + platform;
  }
}